module.exports = __webpack_public_path__ + "static/media/logo.2e07cec3.svg";